import { useEffect } from "react";
import { ErrorBoundary as ExpoRouterErrorBoundary, type ErrorBoundaryProps } from "expo-router";
import { reportError } from "@visioni/a3s-error-reporting";

/**
 * Exported as `ErrorBoundary` from the root layouts: Expo Router renders it when a
 * screen throws while rendering, unless the screen exports its own. An error a
 * boundary catches never reaches Sentry's global handler, so it is reported here.
 */
export function RouteErrorBoundary(props: ErrorBoundaryProps) {
  useEffect(() => {
    reportError(props.error, { tags: { boundary: "route" } });
  }, [props.error]);

  return <ExpoRouterErrorBoundary {...props} />;
}
